import { render, staticRenderFns } from "./StarterNavbar.vue?vue&type=template&id=4c8d4d61&scoped=true&"
import script from "./StarterNavbar.vue?vue&type=script&lang=js&"
export * from "./StarterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./StarterNavbar.vue?vue&type=style&index=0&id=4c8d4d61&prod&scoped=true&lang=css&"
import style1 from "./StarterNavbar.vue?vue&type=style&index=1&id=4c8d4d61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d4d61",
  null
  
)

export default component.exports